/* eslint-disable */
import axios from 'axios';
import router from '../router';

export default class Server {
  axios(method, url, params) {
    return new Promise((resolve, reject) => {
      if (typeof params !== 'object') {
        params = {};
      }
      let _option = {
        method,
        url,
        params: null,
        data: null,
        headers: null,
      };
      Object.keys(params).forEach((obj) => {
        _option = Object.assign({}, _option, params[obj]);
      });
      axios
        .request(_option)
        .then((res) => {
          if (res.data.state === 301 || res.data.state === 302 || res.data.state === 503) {
            window.sessionStorage.removeItem('initInfo');
            router.replace('/');
            // this.$router.push({ name: 'login' });
          } else if (res.data) {
            if (typeof res.data === 'object') {
              resolve(res.data);
            } else {
              try {
                resolve(JSON.parse(res.data));
              } catch (err) {
                resolve(res.data);
              }
            }
            // resolve(typeof res.data === 'object' ? res.data : JSON.parse(res.data));
          } else {
            resolve('');
          }
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            reject(error.response.data);
          } else {
            reject(error);
          }
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/api/server.js